/** Images */
import { ReactComponent as Line } from "../../assets/line.svg";
import BannerGuy from "../../assets/banner-guy.png";

/** MUI */
import {
    Box,
    Container,
    Grid2 as Grid,
    Typography,
} from "@mui/material";

/** Components */
import classes from "./banner.module.css";
import BaseButton from "../ui/BaseButton";

const Banner = (props) => {
    const { type, scrollToSection } = props;

    const goToApp = () => {
        if (type === "own") {
            window.open("https://go.noddok.com/?try-noddok=true&language=en", "_blank");
        } else if(type === "xero") {
            // Go contact
            scrollToSection();
        } else {
            window.open("https://go.noddok.com", "_blank");
        }
    };

    return (
        <Box className={classes.background}>
            <Box className={classes.svgcontainer}>
                <Line />
            </Box>
            <Container maxWidth="xl" disableGutters>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8, xxl: 7 }}>
                        <Box className={classes.textcontainer}>
                            <Typography variant="h1" color="secondary" className={classes.paddingB}>
                                Close your books twice as fast
                            </Typography>
                            <Typography variant="h2" color="V040" className={classes.paddingBM}>
                                Transform your financial reporting with our AI-powered technology
                            </Typography>
                            <ul className={classes.list}>
                                <li>
                                    <Typography variant="body1">
                                        Seamless{" "}
                                        <Typography component="span" fontWeight={700} variant="body1">
                                            integration with Quickbooks
                                        </Typography>{" "}
                                        and{" "}
                                        <Typography component="span" fontWeight={700} variant="body1">
                                            Xero.
                                        </Typography>
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body1">
                                        Blazing fast data extraction from{" "}
                                        <Typography component="span" fontWeight={700} variant="body1">
                                            checks, bills
                                        </Typography>{" "}
                                        and{" "}
                                        <Typography component="span" fontWeight={700} variant="body1">
                                            bank statements.
                                        </Typography>
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body1">
                                        Accurate and detailed categorization for{" "}
                                        <Typography component="span" fontWeight={700} variant="body1">
                                            Square, Stripe
                                        </Typography>{" "}
                                        and{" "}
                                        <Typography component="span" fontWeight={700} variant="body1">
                                            Amazon.
                                        </Typography>
                                    </Typography>
                                </li>
                            </ul>
                            <Grid container spacing={2} justifyContent="space-between" alignItems="center" className={classes.cta}>
                                <Grid size="auto">
                                    <BaseButton
                                        onClick={goToApp}
                                        variantType="secondaryContainedButton"
                                        sizebutton="l"
                                        disableElevation
                                    >
                                        {type === "xero" ? "I'm interested" : "Try Noddok for free"}
                                    </BaseButton>
                                </Grid>
                                <Grid size="auto">
                                    <Box id="pricing">
                                        <Typography color="V040" gutterBottom variant="body2">
                                            25 pages | 14 days
                                        </Typography>
                                        <Typography color="V040" gutterBottom variant="body2">
                                            All features available
                                        </Typography>
                                        <Typography color="V040" variant="body2">No card required</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4, xxl: 5 }} className={classes.bannerGuyBox}>
                        <img src={BannerGuy} alt="Banner Guy" className={classes.bannerGuy} />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Banner;